import _extends from "@babel/runtime/helpers/extends";
import * as React from "react";
import { forwardRef } from "react";
const SvgComponent = (props, ref) => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: "1em",
  height: "1em",
  fill: "none",
  viewBox: "0 0 20 20",
  ref: ref
}, props), /*#__PURE__*/React.createElement("path", {
  fill: "currentColor",
  fillRule: "evenodd",
  d: "M11.982 4.836a2.825 2.825 0 0 0-3.964 0 2.74 2.74 0 0 0 0 3.905 2.825 2.825 0 0 0 3.964 0 2.74 2.74 0 0 0 0-3.905m-4.95-.995a4.225 4.225 0 0 1 5.935 0 4.14 4.14 0 0 1 0 5.895 4.225 4.225 0 0 1-5.934 0 4.14 4.14 0 0 1 0-5.895M6.5 13.219c-1.166 0-2.1.934-2.1 2.072v1.386a.7.7 0 1 1-1.4 0V15.29c0-1.925 1.574-3.472 3.5-3.472h8v1.4z",
  clipRule: "evenodd"
}), /*#__PURE__*/React.createElement("path", {
  fill: "currentColor",
  fillRule: "evenodd",
  d: "M16.374 9.7a.7.7 0 0 1 .495.205l1.826 1.826a.7.7 0 0 1 0 .99l-4.929 4.929a.7.7 0 0 1-.412.2l-2.072.245a.7.7 0 0 1-.777-.777l.245-2.072a.7.7 0 0 1 .2-.412l4.929-4.929a.7.7 0 0 1 .495-.205m-4.262 5.952-.112.949.948-.113 4.262-4.262-.836-.836z",
  clipRule: "evenodd"
}));
const ForwardRef = /*#__PURE__*/forwardRef(SvgComponent);
export default ForwardRef;
//# sourceMappingURL=UserWithPencil20.js.map